import * as React from 'react'
import Draggable from 'react-draggable'
import '../styles.scss'

interface QANoteProps {
  list: Array<string>
}

const QANote = (props: QANoteProps) => {
  // Arrows / Collabsible
  const arrowClasses = ['none', 'top', 'right', 'bottom', 'left']
  const cursorClasses = [
    'not-allowed',
    'n-resize',
    'e-resize',
    's-resize',
    'w-resize',
  ]
  const [arrowPosition, setArrowPosition] = React.useState(0)
  const [expanded, setExpanded] = React.useState(true)

  const baseCSSClass = 'qa-note'

  return (
    <div
      className={`${baseCSSClass} ${baseCSSClass}--${
        expanded ? 'expanded' : 'collapsed'
      }`}
    >
      <Draggable handle={`.${baseCSSClass}__icon`}>
        <div className={`${baseCSSClass}__wrapper`}>
          <div
            className={`${baseCSSClass}__arrow ${baseCSSClass}__arrow--${
              arrowClasses[arrowPosition % 5]
            }`}
          />
          <i
            className={`${baseCSSClass}__icon`}
            onDoubleClick={() => {
              setExpanded(!expanded)
            }}
          />
          <div className={`${baseCSSClass}__content`}>
            <ul
              className={`${baseCSSClass}__list`}
              onClick={() => {
                setArrowPosition(arrowPosition + 1)
              }}
              style={{
                cursor: cursorClasses[(arrowPosition + 1) % 5],
              }}
            >
              {props.list.map((item, key) => (
                <li key={key}>{item}</li>
              ))}
            </ul>
          </div>
        </div>
      </Draggable>
    </div>
  )
}

export default QANote
